export const WAREHOUSE_UPDATE_REQUEST = "WAREHOUSE_UPDATE_REQUEST"
export const WAREHOUSE_UPDATE_SUCCESS = "WAREHOUSE_UPDATE_SUCCESS"
export const WAREHOUSE_UPDATE_FAILED = "WAREHOUSE_UPDATE_FAILED"

export const WAREHOUSE_REGISTER_REQUEST = "WAREHOUSE_REGISTER_REQUEST"
export const WAREHOUSE_REGISTER_SUCCESS = "WAREHOUSE_REGISTER_SUCCESS"
export const WAREHOUSE_REGISTER_FAILED = "WAREHOUSE_REGISTER_FAILED"
